import { Modal, ModalHeader, ModalBody, ModalFooter } from 'components/ui/Modal'
import { useTranslation } from 'react-i18next'
import { useFormik } from 'formik'
import { UIButton } from 'components/ui/Button'
import { useState } from 'react'
import { useGetAreas } from 'api/areas'
import { openNewChat } from 'api/chats'
import { isUndefined } from 'lodash'
import { createValidationSchema, required } from 'utils/validations'
import clsx from 'clsx'
import { useGetBotMode } from 'hooks/useGetBotMode'
import { useGetSetting } from 'api/settings'
import { InputRadioExpandable } from 'components/ui/InputRadioExpandable'
import { useModal } from 'providers/ModalProvider'

export const OpenChatModal = () => {
  const { t } = useTranslation()
  const { setting } = useGetSetting()
  const [loading, setLoading] = useState(false)
  const { isAppMode } = useGetBotMode()
  const { close } = useModal()

  const { data } = useGetAreas()

  const { values, setFieldValue, handleSubmit } = useFormik({
    initialValues: {
      areaId: undefined,
    },
    validationSchema: createValidationSchema({
      areaId: required,
    }),
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values) => {
      if (!values.areaId) return
      try {
        setLoading(true)
        await openNewChat({
          areaId: values.areaId,
        })
        setLoading(false)
        close()
      } catch (e) {
        console.error({ e })
        setLoading(false)
      }
    },
  })

  const handleAreaSelection = (areaId: string) => {
    setFieldValue('areaId', areaId)
  }

  return (
    <Modal onClose={close}>
      <ModalHeader title={t('selectAreaToOpenChat')} icon="comments" />
      <ModalBody className={clsx(isAppMode ? 'modal-container-app' : `modal-container`)}>
        <div
          className="tw-scrollbar-widget tw-flex tw-flex-col tw-overflow-y-auto"
          style={{ '--widget-color': setting?.primaryColor || '#888' } as React.CSSProperties}
        >
          {data.map((area) => (
            <div key={area._id} className={'tw-mt-2 tw-mr-2 tw-border-b-[1px]'}>
              <InputRadioExpandable
                key={area._id}
                value={area._id}
                label={area.name}
                disabled={area.numberOfAreaSources === 0}
                childrens={area.children}
                selectedValue={values.areaId}
                onChange={handleAreaSelection}
              />
            </div>
          ))}
        </div>
      </ModalBody>
      <ModalFooter>
        <UIButton
          className={'tw-w-full'}
          onClick={() => handleSubmit()}
          loading={loading}
          disabled={isUndefined(values.areaId)}
        >
          <span className={'tw-text-sm'}>{t('confirm')}</span>
        </UIButton>
      </ModalFooter>
    </Modal>
  )
}
